import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchSignupRequirementsActions = createDataModuleActions(
    'FETCH_SIGNUP_REQUIREMENTS',
);
export const fetchSignupRequirements =
    fetchSignupRequirementsActions.dataRequest;
export const fetchSignupRequirementsSuccess =
    fetchSignupRequirementsActions.dataSuccess;
export const fetchSignupRequirementsError =
    fetchSignupRequirementsActions.dataError;
export const fetchSignupRequirementsReset =
    fetchSignupRequirementsActions.dataReset;
